import React from 'react';
import './BonusButton.css';

function BonusButton({
    labelText = 'Get Bonus',
    active = false,
    onClick = () => {},
}) {
  return (
    <div className={`bonus-button ${active ? 'active' : 'inactive'}`} onClick={onClick}>
      <label>{labelText}</label>
    </div>
  );
}

export default BonusButton;
